// extracted by mini-css-extract-plugin
export default {"splash":"bootSplash_splash__XNK9g","text":"bootSplash_text__e-8qc"};